<span [innerHTML]="sanitizedIcon" ></span>
<span [innerHTML]="proofReader" ></span>
<span [innerHTML]="essayChecker" ></span>
<span [innerHTML]="footerIcon" ></span>
<span [innerHTML]="grammarcheckIcon" ></span>
<span [innerHTML]="sentencecheckIcon" ></span>
<span [innerHTML]="allToolsIcon" ></span>
<span [innerHTML]="plagiarismIcon" ></span>
<span [innerHTML]="helpingToolsIcons" ></span>
<span [innerHTML]="modalsIcons" ></span>
<span [innerHTML]="headericons" ></span>
<span [innerHTML]="homemages" ></span>
<span [innerHTML]="accounticon" ></span>
